import React from 'react';
import styled from 'styled-components';

import ChevronIcon from 'chevron-down.svg';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition, @typescript-eslint/no-explicit-any
export const ChevronDownIcon = (props: any) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <ChevronIcon width="15" height="9" {...props} />
);
export const ChevronUpIcon = styled(ChevronDownIcon)`
  transform: rotate(180deg);
`;
export const ChevronLeftIcon = styled(ChevronDownIcon)`
  transform: rotate(90deg);
`;
export const ChevronRightIcon = styled(ChevronDownIcon)`
  transform: rotate(-90deg);
`;
